import React, { useState,useEffect } from "react";
import styles from "./OverviewCard.module.css";
import { FaChevronDown } from "react-icons/fa";
import { GiPlainCircle } from "react-icons/gi";
import { updateProjectStatus } from "../../api/Api";
import { showToast } from "../../utils/toastUtils";

// Status labels 
const statusLabels = {
  planning: "Planning",
  underReview: "Under Review",
  preAward: "Pre-award",
  active: "Active",
  completion: "Completion",
  impact: "Impact",
  archivedClosed: "Archived/Closed",
};

const statusColors = {
  planning: "#f0b22d",        // orange
  underReview: "#fff707",     // yellow
  preAward: "#0dcaf0",        // cyan
  active: "#198754",          // green
  completion: "#0d6efd",      // blue
  impact: "#6610f2",          // purple
  archivedClosed: "#e51c26",  // red
};

const statusOptions = Object.keys(statusLabels);

function OverviewCard({ cardData }) {
  const [status, setStatus] = useState(cardData.status);
  const [dropdownVisible, setDropdownVisible] = useState(false);

  // Set initial status from cardData
  useEffect(() => {
    setStatus(cardData.status);
  }, [cardData.status]);

  const handleStatusChange = async (newStatus) => {
    if (newStatus === status) return;

    try {
      const res = await updateProjectStatus(cardData.id, { status: newStatus });
      if (res?.status === 200 || res?.status === "success") {
        setStatus(newStatus);
        setDropdownVisible(false);
        showToast("Status updated successfully", "success");
      } else {
        console.error("Status update failed");
      }
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  return (
    <div className={`${styles.overview} p-4 rounded-4 position-relative`}>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div className={`${styles.title} fw-bold`}>{cardData.name}</div>
        {cardData?.isProject && (
          <div className="position-relative">
            <button
              onClick={() => setDropdownVisible(!dropdownVisible)}
              className={`${styles.statusButton} rounded-pill d-flex align-items-center gap-2`}
            >
              <GiPlainCircle size={12} color={statusColors[status]} />
              <span className="fw-semibold">{statusLabels[status]}</span>
              <FaChevronDown size={12} />
            </button>

            {dropdownVisible && (
              <ul
                className={`${styles.dropdown} position-absolute bg-white rounded shadow p-2`}
                style={{ top: "110%", right: 0, zIndex: 1000, listStyle: "none" }}
              >
                {statusOptions.map((option) => (
                  <li
                    key={option}
                    className="p-1 px-2 border-bottom"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleStatusChange(option)}
                  >
                    {statusLabels[option]}
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}
      </div>
      <div>{cardData.description}</div>
    </div>
  );
}

export default OverviewCard;
